/** Paths to static files in `public/` (served from site root). */

export const PUBLIC_IMAGES = {
  logo: '/images/VM.jpeg',
  logoBlack: '/images/VM_logo_regular_blackRGB.png',
  /** Icon-only mark (no wordmark) — use for watermarks / marks */
  logoMark: '/images/vm-mark.png',
  dynamicsLogo: '/images/Dynamics-365-logo.png',
  klaviyoLogo: '/images/Klaviyo-logo.png',
  quickbooksLogo: '/images/QuickBooks-Logo.png',
  economicLogo: '/images/economic-logo.svg',
  hubspotLogo: '/images/hubspot-logo.svg',
  mobilepayLogo: '/images/mobilepay-logo.svg',
};

export const PUBLIC_ICONS = {
  aiAssistant: '/icons/AI.png',
  events: '/icons/events.png',
  trends: '/icons/trends.png',
  products: '/icons/product.png',
};
